export default __webpack_public_path__ + "static/order-in-store-eec6298b9c3fb67f8a240b6663229dfb.svg";